import "./footer.css";

export function Footer(){
    return(<div className="footer">
       Made with 🔥 By Aditya Pathak
    </div>)
}